<template>
    <div class="container-fluid layout-wrapper">
        <div class="row">
            <div class="col-12">
                <div class="card shadow">
                    <div class="card-header admin-header">
                        <h4 class="text-accent-light">گزارش پرداختهای کاربر</h4>
                    </div>
                    <!--<div class="card-body">-->
                        <!--<div class="row">-->
                            <!--<div class="col-lg-6 col-sm-6 mb-3">-->
                                <!--<div class="input-group round">-->
                                    <!--<div class="input-group-prepend">-->
                                        <!--<span class="input-group-text">نوع حساب</span>-->
                                    <!--</div>-->
                                    <!--<vs-select @onSearch="onDropDownFocused" @onSearchBlurred="onDropDownBlurred"-->
                                               <!--:data="types" :mode="'create'"-->
                                               <!--:header="{multiple: false, label: 'name'}"-->
                                               <!--@onChange="onTypeChange">-->
                                    <!--</vs-select>-->
                                <!--</div>-->
                            <!--</div>-->
                            <!--<div class="col-lg-6 col-sm-6 mb-3">-->
                                <!--<div class="input-group round">-->
                                    <!--<div class="input-group-prepend">-->
                                        <!--<span class="input-group-text">نوع عملیات</span>-->
                                    <!--</div>-->
                                    <!--<vs-select @onSearch="onDropDownFocused" @onSearchBlurred="onDropDownBlurred"-->
                                               <!--:data="opType" :mode="'create'"-->
                                               <!--:header="{multiple: false, label: 'name'}"-->
                                               <!--@onChange="onOpTypeChange">-->

                                    <!--</vs-select>-->
                                <!--</div>-->
                            <!--</div>-->

                            <!--<div class="col-lg-6 col-sm-6 mb-3">-->
                                <!--<div class="input-group round">-->
                                    <!--<div class="input-group-prepend">-->
                                        <!--<span class="input-group-text">از تاریخ</span>-->
                                    <!--</div>-->
                                    <!--<date-picker type="datetime" class="date-picker" format="jYYYY/jMM/jDD"-->
                                                 <!--@input="onFromDatePicked" ref="fromDate"-->
                                                 <!--style="flex: 1; display: flex;">-->
                                        <!--<input class="form-control flex-grow-1 date-text-input" v-model="fromDate"-->
                                               <!--@click="toggleFromDatePicker">-->
                                    <!--</date-picker>-->
                                <!--</div>-->
                            <!--</div>-->
                            <!--<div class="col-lg-6 col-sm-6 mb-3">-->
                                <!--<div class="input-group round">-->
                                    <!--<div class="input-group-prepend">-->
                                        <!--<span class="input-group-text">تا تاریخ</span>-->
                                    <!--</div>-->
                                    <!--<date-picker type="datetime" class="date-picker" format="jYYYY/jMM/jDD"-->
                                                 <!--@input="onToDatePicked" ref="toDate"-->
                                                 <!--style="flex: 1; display: flex;">-->
                                        <!--<input class="form-control flex-grow-1 date-text-input" v-model="toDate"-->
                                               <!--@click="toggleToDatePicker">-->
                                    <!--</date-picker>-->
                                <!--</div>-->
                            <!--</div>-->


                        <!--</div>-->

                        <!--<preloader v-if="isLoading"/>-->
                    <!--</div>-->

                    <div v-if="!isLoading">
                        <div v-if="PaymentReport.length===0">
                            <h5 class="text-center mt-3">شما سابقه ثبت فیش ندارید</h5>
                        </div>
                        <div class="table-responsive" v-else>
                                <table class="table table-hover table-striped">
                                    <thead>
                                    <tr>
                                        <th>تاریخ ثبت</th>
                                        <th>نام بانک</th>
                                        <th>تاریخ فیش</th>
                                        <th>شماره فیش</th>
                                        <th>مبلغ قسط</th>
                                        <th>مبلغ سپرده</th>
                                        <th>مجموع واریزی</th>
                                        <th>توضیحات</th>
                                        <th>وضعیت ثبت</th>

                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr v-for="it in PaymentReport">
                                        <td>{{it.prdatecreate}}</td>
                                        <td>{{it.bankAccountName}}</td>
                                        <td>{{it.prdateresipt}}</td>
                                        <td>{{it.receiptNumber}}</td>
                                        <td>{{it.loanAmount.toLocaleString()}}</td>
                                        <td>{{it.depositAmount.toLocaleString()}}</td>
                                        <td>{{it.totalAmount.toLocaleString()}}</td>
                                        <td>{{it.description}}</td>
                                        <td>{{it.voucherStatus}}</td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    import BaseService from "../_framework/api/BaseService";
    import Utils from "../_framework/utils/Utils";
    import VsSelect from "../_framework/VsSelect";
    import DatePicker from "../_framework/vue-persian-datetime-picker/VuePersianDatetimePicker";
    import Moment from "moment-jalali";

    export default {
        name: "paymentreport",
        components: {VsSelect, DatePicker},
        data() {
            return {
                isLoading: false,
                types: [{
                    id: 6,
                    name: "سپرده قرض الحسنه"
                }],
                opType: [
                    {
                        id: 0,
                        name: "واریزها"
                    },
                    {
                        id: 1,
                        name: "برداشتها"
                    },
                    {
                        id: 2,
                        name: "واریز و برداشت"
                    },

                ],
                PaymentReport: [],


                reportModel: {
                    fromDate: "",
                    toDate: "",
                    type: 0,
                    isDebtor: null
                },
                fromDate: "",
                toDate: "",

            }
        },
        mounted() {
            // this.getUserCompetitions();
            // this.getFields();
            // this.getProvinces();
            this.getPaymentReport();
        },
        methods: {
            getPaymentReport() {
                this.isLoading = true;
                // new BaseService("Report",
                //     "/DepositReport/fromDate=" + this.reportModel.fromDate + "/toDate=" + this.reportModel.toDate + "/type=" + this.reportModel.type + "/isDebtor=" + this.reportModel.isDebtor
                // ).getList().then(response => {
                new BaseService("BankReceipt", "/BankReceiptReport").create().then(response => {
                    this.isLoading = false;
                    this.PaymentReport = response.data.data;
                    for (let it of this.PaymentReport) {
                        // for (let me of it.depositDetails) {
                            it.prdatecreate = Moment(it.createdOn, 'YYYY-MM-DD').format('jYYYY/jMM/jDD')
                            it.prdateresipt = Moment(it.receiptDate, 'YYYY-MM-DD').format('jYYYY/jMM/jDD')
                        // }
                    }
                    // this.userMatchesPagination.currentPage = response.data.pageIndex + 1;
                    // this.userMatchesPagination.totalRows = response.data.count;
                }).catch(error => {
                    Utils.handleErrorWithNotification(error.data, this.$noty);
                })
            },


            toggleFromDatePicker() {
                this.$refs.fromDate.togglePicker();
            },
            onFromDatePicked(val) {
                this.reportModel.fromDate = this.jalaliToGregorian(val);
                this.fromDate = this.gregorianToJalaliBeautified(this.jalaliToGregorian(val), true);
                this.getDepositReport();
            },
            toggleToDatePicker() {
                this.$refs.toDate.togglePicker();
            },
            onToDatePicked(val) {
                this.reportModel.toDate = this.jalaliToGregorian(val);
                this.toDate = this.gregorianToJalaliBeautified(this.jalaliToGregorian(val), true);
                this.getDepositReport();
            },
            onPaymentConfirmed() {
                if (this.paymentMethod === "online") {
                    this.payOnline();
                }
                if (this.paymentMethod === "cash") {
                    this.payByCash();
                }
                if (this.paymentMethod === "wallet") {
                    this.payByWallet();
                }
            },

            onShowDiagramClicked(id) {
                this.tournamentBracketId = id;
                this.$refs.tournamentBracketModal.showModal();
            },

            validateDate(date) {
                return Moment(date, 'YYYY-MM-DD').format('jDD jMMMM jYYYY')
            },
            onTypeChange(val) {
                if (val !== null) {
                    this.reportModel.type = val.id;
                    this.getDepositReport();
                } else {
                    this.reportModel.type = 0;
                    this.getDepositReport();
                }
            },
            onOpTypeChange(val) {
                if (val !== null) {
                    switch (val.id) {
                        case 0:
                            this.reportModel.isDebtor = false;
                            this.getDepositReport();
                            break;
                        case  1:
                            this.reportModel.isDebtor = true;
                            this.getDepositReport();

                            break;
                        case  2:
                            this.reportModel.isDebtor = null;
                            this.getDepositReport();

                            break;
                    }

                } else {
                    this.reportModel.type = 0;
                    this.getDepositReport();
                }
            },
        }
    }
</script>

<style lang="scss" scoped>
    .payment-options-container {
        display: flex;
        justify-content: space-evenly;
        align-items: center;
        width: 100%;
        margin-top: 1.5rem;
    }

    .payment-option {
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        align-items: center;
        background-color: #ffffff;
        border-radius: 0.25rem;
        padding: 0.5rem;
        box-shadow: 0 5px 15px -2px rgba(0, 0, 0, 0.5);
        border: 2px solid transparent;
        cursor: pointer;
        transition: all 0.3s;
    }

    .payment-option.active {
        border: 2px solid #40c4ff;
        box-shadow: 0 5px 15px -2px #40c4ff;
    }

    .payment-option img {
        max-width: 100px;
    }

    .payment-option small {
        color: #333333;
        margin-top: 0.5rem;
    }

    .wallet-payment-wrapper {
        height: 150px;
        display: flex;
        justify-content: center;
        align-items: center;
    }
</style>